import React, { useEffect } from "react";
// styled components
import { Divider, Form, Button } from "antd";
//  redux
import { useDispatch } from "react-redux";
// api services
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
// hooks
import { useCronogramaActividades } from "./useCronogramaActividades";

import { useEncrypt } from "../../../../../hooks/useEncrypt";
import DateInput from "../../../../../utils/DateInput";
import { edicionConvocatoria } from "../../../../../redux/actions/convocatoriaAction";
// models
interface IProps {
  cambiarPestaña: any;
}

export const CronogramaActividades: React.FC<IProps> = (props: IProps) => {
  // redux
  // const { idConvocatoria } = useSelector((state: any) => state.convocatoria);
  const { decrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  const dispatch = useDispatch();

  const cargarConvocatoria = async () => {
    let { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoria);
    let infoupdate = { ...fechasbeps };
    if (data && data.fechas && data.fechas.length > 0) {
      infoupdate = {
        ...infoupdate,
        fecha_apertura: data.fechas[0].valormin || "",
        fecha_cierre: data.fechas[1].valormin || "",
        fecha_informeinscritos: data.fechas[2].valormin || "",
        fecha_subsanacion: data.fechas[3].valormin || "",
        fecha_finalinscritos: data.fechas[4].valormin || "",
      };
    }
    return setFechasBeps(infoupdate);
  };
  useEffect(() => {
    cargarConvocatoria();
  }, []);

  const { fechasbeps, setFechasBeps, guardarycontinuar } =
    useCronogramaActividades();

  // campos formulario
  const fields = [
    { name: "fecha_apertura", value: fechasbeps.fecha_apertura },
    { name: "fecha_cierre", value: fechasbeps.fecha_cierre },
    {
      name: "fecha_informeinscritos",
      value: fechasbeps.fecha_informeinscritos,
    },
    { name: "fecha_subsanacion", value: fechasbeps.fecha_subsanacion },
    { name: "fecha_finalinscritos", value: fechasbeps.fecha_finalinscritos },
  ];

  return (
    <>
      <div className="container-fluid ps-md-4 pe-md-4 main-c4">
        <div className="row-shadow mt-3 mb-3">
          <div className="container-row-shadow">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-8 pb-2 font-size-14px font-family-Montserrat-Regular">
                Cronograma de actividades para la convocatoria BEPS -{" "}
                <span className="font-size-10px font-color-9F0505">
                  Todos los campos son obligatorios
                </span>
              </div>
              <div className="col-8 col-md-12 col-lg-4 pb-2 d-flex justify-content-lg-end font-color-B0B0B0 font-size-12px font-family-Montserrat-Regular">
                Código de convocatoria: {idConvocatoria}
              </div>
            </div>
            <Divider style={{ marginTop: "1%", marginBottom: "1%" }} />

            <Form
              name="cronogramaactividadesjurados"
              size="large"
              layout="vertical"
              className="width-100"
              fields={fields}
              onFieldsChange={(_: any, fields: any) => {
                let infoupdate: any = { ...fechasbeps };
                infoupdate[_[0].name[0]] = _[0].value;
                return setFechasBeps(infoupdate);
              }}
              onFinish={() => {
                guardarycontinuar(props.cambiarPestaña);
              }}
            >
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6">
                  <Form.Item
                    className="no-margin"
                    label="Fecha apertura"
                    name="fecha_apertura"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setFechasBeps({
                          ...fechasbeps,
                          fecha_apertura: fecha,
                        });
                      }}
                      dia={fechasbeps.fecha_apertura.split("-")[2] || ""}
                      mes={fechasbeps.fecha_apertura.split("-")[1] || ""}
                      anio={fechasbeps.fecha_apertura.split("-")[0] || ""}
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                  <Form.Item
                    className="no-margin"
                    label="Fecha de cierre"
                    name="fecha_cierre"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setFechasBeps({
                          ...fechasbeps,
                          fecha_cierre: fecha,
                        });
                      }}
                      dia={fechasbeps.fecha_cierre.split("-")[2] || ""}
                      mes={fechasbeps.fecha_cierre.split("-")[1] || ""}
                      anio={fechasbeps.fecha_cierre.split("-")[0] || ""}
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                  <Form.Item
                    className="no-margin"
                    label="Informe de inscritos"
                    name="fecha_informeinscritos"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setFechasBeps({
                          ...fechasbeps,
                          fecha_informeinscritos: fecha,
                        });
                      }}
                      dia={
                        fechasbeps.fecha_informeinscritos.split("-")[2] || ""
                      }
                      mes={
                        fechasbeps.fecha_informeinscritos.split("-")[1] || ""
                      }
                      anio={
                        fechasbeps.fecha_informeinscritos.split("-")[0] || ""
                      }
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                  <Form.Item
                    className="no-margin"
                    label="Subsanación"
                    name="fecha_subsanacion"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setFechasBeps({
                          ...fechasbeps,
                          fecha_subsanacion: fecha,
                        });
                      }}
                      dia={fechasbeps.fecha_subsanacion.split("-")[2] || ""}
                      mes={fechasbeps.fecha_subsanacion.split("-")[1] || ""}
                      anio={fechasbeps.fecha_subsanacion.split("-")[0] || ""}
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                  <Form.Item
                    className="no-margin"
                    label="Listado final de inscritos"
                    name="fecha_finalinscritos"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setFechasBeps({
                          ...fechasbeps,
                          fecha_finalinscritos: fecha,
                        });
                      }}
                      dia={fechasbeps.fecha_finalinscritos.split("-")[2] || ""}
                      mes={fechasbeps.fecha_finalinscritos.split("-")[1] || ""}
                      anio={fechasbeps.fecha_finalinscritos.split("-")[0] || ""}
                    />
                  </Form.Item>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <div className="container-sticky-footer">
        <div className="row">
          <div className="col justify-content-flex-start">
            <Button
              className="button-blanco-radius"
              onClick={() => {
                dispatch(edicionConvocatoria(true));
                props.cambiarPestaña("1");
              }}
            >
              Atrás
            </Button>
          </div>
          <div className="col justify-content-flex-end">
            <Button
              className="button-azul-radius"
              htmlType="submit"
              form="cronogramaactividadesjurados"
            >
              Guardar y continuar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
